export default "__VITE_ASSET__4b7a7db0__"